<template>
  <div style="width: fit-content; min-width: 100%">
    <div class="navbar">
      <button
        class="btn btn-light d-flex align-items-center"
        style="margin-right: 190px"
        @click="$router.go(-1)"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          size="16"
          class="mr-50"
        />
        Kembali
      </button>

      <div class="d-none d-md-block font-weight-bold">
        {{ invoice }}
      </div>

      <div
        class="d-flex"
        style="gap: 0.5rem;"
      >
        <button
          class="btn btn-outline-primary d-flex align-items-center"
          :disabled="!invoiceHtml || isDownloading"
          @click="printInvoice"
        >
          <feather-icon
            icon="PrinterIcon"
            size="16"
            class="mr-50"
          />
          Cetak Invoice
        </button>

        <button
          class="btn btn-primary d-flex align-items-center"
          :disabled="!invoiceHtml || isDownloading"
          @click="downloadInvoice"
        >
          <feather-icon
            icon="DownloadIcon"
            size="16"
            class="mr-50"
          />
          Download
        </button>
      </div>
    </div>

    <div
      style="display: flex; width: 100%; max-width: 100%; overflow: auto"
      class="iframe-container p-1"
    >
      <div
        v-if="isLoading"
        class="text-center py-5 mx-auto"
      >
        <b-spinner variant="primary" />
        <div class="mt-1">
          Memuat invoice...
        </div>
      </div>
      <iframe
        v-else
        :srcdoc="invoiceHtml"
        style="width: 800px; height: 1132px; min-width: 800px; min-height: 1132px"
        class="border border-secondary rounded-lg mx-auto"
        frameborder="0"
      />
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

export default {
  components: {
    BSpinner,
  },
  data() {
    return {
      transactionId: this.$route.params.id,
      invoice: this.$route.query.invoice ? `Invoice Miniapoly - ${this.$route.query.invoice}` : 'Invoice Miniapoly',
      invoiceHtml: '',
      isLoading: false,
      isDownloading: false,
    }
  },
  mounted() {
    document.title = this.invoice
    this.loadInvoice()
  },
  methods: {
    invoicePath() {
      return `/v1/orders/${this.transactionId}/invoice`
    },
    async loadInvoice() {
      this.isLoading = true
      try {
        const { data } = await this.$http.get(this.invoicePath(), {
          responseType: 'text',
        })
        this.invoiceHtml = data
      } finally {
        this.isLoading = false
      }
    },
    printInvoice() {
      window.print()
    },
    async downloadInvoice() {
      this.isDownloading = true
      try {
        const response = await this.$http.get(this.invoicePath(), {
          params: { dl: 1 },
          responseType: 'blob',
        })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.invoice}.pdf`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } finally {
        this.isDownloading = false
      }
    },
  },
}
</script>

<style>
/* Optional custom styles for your page or iframe */
body {
  height: 100vh;
  background-color: #F5F5F0;
}

@media print {
  @page {
    size: 550px 778px;
    margin: 0;
    page-break-inside: avoid;
  }

  /* Hide elements that should not appear in the print */
  .navbar, .btn, .d-flex {
    display: none !important;
  }

  /* Remove iframe border and rounded corners */
  iframe.border {
    border: none !important;
  }
  iframe.rounded-lg {
    border-radius: 0 !important;
  }

  /* Ensure full A4 page size */
  body, html {
    width: 550px !important;
    height: 778px !important;
    margin: 0;
    padding: 0;
  }

  /* Scale content to fit A4 */
  iframe {
    width: 100% !important;
    height: 100% !important;
    min-width: unset !important;
    min-height: unset !important;
  }

  .iframe-container {
    padding: 0 !important;
    line-height: 0 !important;
    display: block !important;
    width: 100vw !important;
    height: 100vh !important;
  }
}
</style>
